import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Link from "../../../components/Link"

const RasmusPage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  var customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")
  return (
    <Layout location={props.location}>
      <Helmet>
        <html className="memberpage" lang="da" />
      </Helmet>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <div className="space-8"></div>

            <div className="grid">
              <div className="member-2col-left">
                <div className="member-inner">
                  <h1>Rasmus Fredensborg Jensen</h1>
                  <h3>Professional</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Date of employment at Emento
                      </div>
                      <div class="flex-row" role="cell">
                        February 2016
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Title
                      </div>
                      <div class="flex-row" role="cell">
                        Product Engineer
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Responsibilities
                      </div>
                      <div class="flex-row" role="cell">
                        Integrations &amp; Security
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Educational background
                      </div>
                      <div class="flex-row" role="cell">
                        Master of Science in Computer Science
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Previous positions/industries
                      </div>
                      <div class="flex-row" role="cell">
                        Junior Product Developer (Emento)
                      </div>
                    </div>
                  </div>
                  <h3>Personal</h3>
                  <div
                    class="table-container"
                    role="table"
                    aria-label="Destinations"
                  >
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Bucket list no. 1
                      </div>
                      <div class="flex-row" role="cell">
                        Go to Cuba and learn how to play conga drums from a
                        Cuban
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Favorite music
                      </div>
                      <div class="flex-row" role="cell">
                        Jazzfunk
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Biggest food or drink consumption
                      </div>
                      <div class="flex-row" role="cell">
                        Coffee and chilinuts
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Best TV series
                      </div>
                      <div class="flex-row" role="cell">
                        The Wire
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Extraordinary skill
                      </div>
                      <div class="flex-row" role="cell">
                        Drums!
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Preferred traveling style
                      </div>
                      <div class="flex-row" role="cell">
                        Fast and light
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        My friends recognizes me for
                      </div>
                      <div class="flex-row" role="cell">
                        My optimism (and my greying hair)
                      </div>
                    </div>
                    <div class="flex-table row" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        As a kid, I wanted to become
                      </div>
                      <div class="flex-row" role="cell">
                        A professional badminton player or a drummer
                      </div>
                    </div>
                    <div class="flex-table row alt" role="rowgroup">
                      <div class="flex-row first" role="cell">
                        Social links
                      </div>
                      <div class="flex-row" role="cell">
                        <Link
                          to="https://www.facebook.com/Rasmus.Fredensborg"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Facebook
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-middle">
                <div className="member-hero-inner">
                  <div className="member-hero-box">
                    <div className="member-hero-image">
                      <img
                        src="/images/portraits/internal/rasmus_hero.jpg"
                        alt=""
                      />
                    </div>
                    <h3>Feels like: Ross from Friends</h3>
                    Strength
                    <div className="full-bar">
                      <div className="bar size-40" />
                    </div>
                    Artistic
                    <div className="full-bar">
                      <div className="bar size-70" />
                    </div>
                    Spontaneous
                    <div className="full-bar">
                      <div className="bar size-20" />
                    </div>
                    Determined
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Polite
                    <div className="full-bar">
                      <div className="bar size-100" />
                    </div>
                    Playful
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Empathy
                    <div className="full-bar">
                      <div className="bar size-80" />
                    </div>
                    Intelligence
                    <div className="full-bar">
                      <div className="bar size-60" />
                    </div>
                    Brave
                    <div className="full-bar">
                      <div className="bar size-40" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="member-2col-right">
                <div className="member-childhood-inner">
                  <div
                    className="member-childhood-image"
                    style={{
                      backgroundImage: `url(/images/portraits/internal/rasmus_child.jpg)`,
                    }}
                  >
                    <div className="blur-bg">
                      <img
                        src="/images/portraits/internal/rasmus_child.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default RasmusPage
